module.exports = __webpack_public_path__ + "static/media/default-avatar.cf218a61.png";